const OFFICE_IMAGE =
  "https://storage.readdy-site.link/project_files/baa66faa-05ee-46a3-9ac6-c2099951abb1/d3fee0e9-79c4-47e8-b9b0-f7107a7ba9ae_Georges-Humbert-FOTO-2.jpeg?v=fd38f3c92f47320f355d706a5f10bca6";

const pillars = [
  {
    icon: "ri-scales-3-line",
    title: "Atuação Estratégica",
    text: "Escritório com atuação jurídica orientada à estratégia, análise de riscos e resultados consistentes.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Ética e Excelência",
    text: "Compromisso inabalável com a ética profissional, a excelência técnica e os mais elevados padrões jurídicos.",
  },
  {
    icon: "ri-user-star-line",
    title: "Atendimento Personalizado",
    text: "Cada cliente recebe atenção individualizada, com soluções pensadas para sua realidade específica.",
  },
  {
    icon: "ri-focus-3-line",
    title: "Foco no Cliente",
    text: "Proteção integral dos interesses do cliente como prioridade máxima em cada caso assumido.",
  },
];

export default function EscritorioSection() {
  return (
    <section id="escritorio" className="bg-ivory py-24">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Label */}
        <div className="flex items-center gap-3 mb-4">
          <div className="w-8 h-px bg-gold-medium" />
          <span className="text-gold-medium text-xs font-semibold tracking-widest uppercase">
            O Escritório
          </span>
        </div>

        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left: Text Content */}
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-petrol-dark leading-tight mb-6">
              Referência em advocacia <br />
              <span className="text-gold-medium">estratégica</span> na Bahia
            </h2>

            <p className="text-petrol-dark/70 text-base leading-relaxed mb-8">
              A <strong className="text-petrol-dark font-semibold">Georges Humbert Sociedade Individual de Advocacia</strong> atua
              com dedicação, rigor técnico e compromisso ético na defesa dos
              interesses de seus clientes. Com uma visão moderna do direito,
              o escritório une conhecimento jurídico aprofundado à atuação
              estratégica orientada a resultados.
            </p>

            {/* Pillars Grid */}
            <div className="grid sm:grid-cols-2 gap-6">
              {pillars.map((p) => (
                <div
                  key={p.title}
                  className="group flex gap-4 p-5 bg-white rounded-lg border border-silver/40 hover:border-gold-light/50 transition-all duration-300 hover:shadow-none"
                >
                  <div className="w-10 h-10 flex items-center justify-center rounded-md bg-petrol-dark/5 group-hover:bg-petrol-dark/10 transition-colors duration-300 shrink-0">
                    <i className={`${p.icon} text-petrol-dark text-xl`} />
                  </div>
                  <div>
                    <h4 className="text-petrol-dark font-semibold text-sm mb-1">
                      {p.title}
                    </h4>
                    <p className="text-petrol-dark/60 text-xs leading-relaxed">{p.text}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Credential Cards */}
            <div className="flex flex-wrap gap-3 mt-8">
              {[
                { icon: "ri-timer-line", text: "25 anos de experiência" },
                { icon: "ri-award-line", text: "Doutorado" },
                { icon: "ri-medal-line", text: "Pós-Doutorado" },
                { icon: "ri-graduation-cap-line", text: "Mestre em Direito" },
                { icon: "ri-book-open-line", text: "+40 livros" },
              ].map((card) => (
                <div
                  key={card.text}
                  className="flex items-center gap-2 bg-transparent border border-emerald-700/40 rounded-full px-4 py-2 hover:border-emerald-700/70 transition-colors duration-300"
                >
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className={`${card.icon} text-emerald-700 text-sm`} />
                  </span>
                  <span className="text-emerald-700 text-xs font-semibold tracking-wide whitespace-nowrap">
                    {card.text}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Right: Image */}
          <div className="relative flex justify-center">
            <div className="relative z-10 rounded-lg overflow-hidden w-full">
              <img
                src={OFFICE_IMAGE}
                alt="Georges Humbert Advocacia - Advogado em Salvador BA"
                className="w-full h-auto object-contain block"
              />
              {/* Gold accent overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-petrol-darkest/30 to-transparent pointer-events-none" />
            </div>
            {/* Decorative frame */}
            <div className="absolute -bottom-4 -right-4 w-full h-full border-2 border-gold-light/30 rounded-lg z-0" />
            {/* Badge */}
            <div className="absolute bottom-8 left-8 z-20 bg-petrol-dark/90 backdrop-blur-sm border border-gold-light/30 rounded-md px-5 py-4">
              <div className="text-gold-light text-2xl font-bold">OAB/BA</div>
              <div className="text-white/70 text-xs mt-0.5">Inscrito na Ordem</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
